import { Link } from "react-router";
import { routes } from "../../app/routes";
import { usePagedList } from "../../platform/async/usePagedList";
import { PageShell } from "../../platform/ui/PageShell";
import { PagedBoard } from "../../platform/ui/PagedBoard";
import { StateMessage } from "../../platform/ui/StateMessage";
import { ListingCard } from "./ListingCard";
import { fetchListings } from "./shop-api";
import "../blog/blog.css";
import "./shop.css";

export function ShopPage() {
  const listings = usePagedList(fetchListings);
  return (
    <PageShell
      eyebrow="Work with Orla"
      title="Orla's Shop"
      layout="viewport"
      lead="Services and products offered by Orla. Browse a listing, then enquire to agree the scope, final price and payment arrangements."
    >
      {listings.items.length ? (
        <PagedBoard
          items={listings.items}
          getKey={(item) => item.slug}
          renderItem={(item) => <ListingCard listing={item} />}
          canFetchMore={listings.nextCursor !== null && listings.status === "ready"}
          fetching={listings.status === "loading_more"}
          onFetchMore={listings.loadMore}
          label="Shop listings"
          newerLabel="Previous listings"
          olderLabel="More listings"
          itemMinWidthRem={18}
          itemMinHeightRem={16}
          maxColumns={2}
        />
      ) : (
        <div className="blog-state" data-slot="stage">
          {listings.status === "loading" ? (
            <StateMessage tone="loading" title="Fetching listings" />
          ) : null}
          {listings.status === "failed" ? (
            <StateMessage
              tone="error"
              title="The shop could not be loaded"
              action={{ label: "Try again", onSelect: listings.reload }}
            >
              {listings.error?.message}
            </StateMessage>
          ) : null}
          {listings.status === "ready" ? (
            <StateMessage tone="empty" title="Nothing listed yet">
              Orla has not published an offer yet. You can still{" "}
              <Link to={routes.contact()}>write to her</Link> about what you need.
            </StateMessage>
          ) : null}
        </div>
      )}
      {listings.status === "failed_more" ? (
        <StateMessage
          tone="error"
          title="More listings could not be loaded"
          action={{ label: "Try again", onSelect: listings.loadMore }}
        >
          {listings.error?.message}
        </StateMessage>
      ) : null}
      <p className="shop-note">Enquiries only. No payment is taken on this website.</p>
    </PageShell>
  );
}
